export const medicosMock = [
  {
    id: 1,
    nombre: "Gregory House",
    matricula: "MP-45678",
    sedes: ["Sede Central"],
  },
  {
    id: 2,
    nombre: "Sapo Milk",
    matricula: "MN-90123",
    sedes: ["Sede Norte"],
  }
];